import { Icon } from '../icons';
import type { MobileRoute, MobileShellCtx } from './MobileShellCtx';

type TabName = 'overview' | 'apps' | 'alerts' | 'settings';

const TABS: { name: TabName; label: string; Ico: typeof Icon.Overview }[] = [
  { name: 'overview', label: 'Overview', Ico: Icon.Overview },
  { name: 'apps', label: 'Apps', Ico: Icon.Apps },
  { name: 'alerts', label: 'Alerts', Ico: Icon.Bell },
  { name: 'settings', label: 'More', Ico: Icon.Sliders },
];

export function MobileTabBar({ ctx }: { ctx: MobileShellCtx }) {
  const active = activeTab(ctx.route);
  return (
    <nav className="m-tabbar" aria-label="Primary">
      {TABS.map((t) => {
        const isActive = active === t.name;
        return (
          <button
            key={t.name}
            type="button"
            className={`tab-btn ${isActive ? 'active' : ''}`}
            onClick={() => {
              if (t.name === 'alerts') ctx.resetUnreadAlerts();
              ctx.navigate(defaultRouteFor(t.name));
            }}
          >
            <t.Ico size={20} className="tab-ico" />
            <span>{t.label}</span>
            {t.name === 'alerts' && ctx.unreadAlerts > 0 && (
              <span className="tab-badge">{ctx.unreadAlerts > 9 ? '9+' : ctx.unreadAlerts}</span>
            )}
          </button>
        );
      })}
    </nav>
  );
}

function activeTab(route: MobileRoute): TabName {
  if (route.name === 'appdash') return 'apps';
  if (route.name === 'overview') return 'overview';
  if (route.name === 'apps') return 'apps';
  if (route.name === 'alerts') return 'alerts';
  return 'settings';
}

function defaultRouteFor(name: TabName): MobileRoute {
  if (name === 'overview') return { name: 'overview' };
  if (name === 'apps') return { name: 'apps' };
  if (name === 'alerts') return { name: 'alerts', tab: 'events' };
  return { name: 'settings' };
}
